module.exports = __webpack_public_path__ + "img/p6.67a73749.png";